import { render, staticRenderFns } from "./CidadeList.vue?vue&type=template&id=41c65e86"
import script from "./CidadeList.vue?vue&type=script&lang=js"
export * from "./CidadeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports